export interface Category {
  name: string;
  displayName: string;
  url: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    name: 'shoes',
    displayName: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    description: 'Sneakers, boots, slides & more from top spreadsheet finds',
  },
  {
    name: 'hoodies-sweaters',
    displayName: 'Hoodies / Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    description: 'Cozy hoodies, crewnecks & knitwear curated weekly',
  },
  {
    name: 't-shirts',
    displayName: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
    description: 'Graphic tees, basics & limited edition drops',
  },
  {
    name: 'jackets',
    displayName: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-windy-line',
    description: 'Bombers, denim jackets, puffers & outerwear',
  },
  {
    name: 'pants-shorts',
    displayName: 'Pants / Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    description: 'Cargo pants, denim, sweat shorts & more',
  },
  {
    name: 'headwear',
    displayName: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-shield-user-line',
    description: 'Caps, beanies, bucket hats & accessories',
  },
  {
    name: 'sets',
    displayName: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    description: 'Matching tracksuits, co-ord sets & bundles',
  },
  {
    name: 'underwear',
    displayName: 'Underwear / Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-checkbox-blank-line',
    description: 'Boxers, briefs & essential undergarments',
  },
  {
    name: 'jersey',
    displayName: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-basketball-line',
    description: 'Sports jerseys, retro kits & team apparel',
  },
  {
    name: 'accessories',
    displayName: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    description: 'Sunglasses, jewelry, watches & small goods',
  },
  {
    name: 'bags',
    displayName: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-briefcase-line',
    description: 'Backpacks, crossbody bags, totes & luggage',
  },
  {
    name: 'belts',
    displayName: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    description: 'Leather belts, designer buckles & streetwear styles',
  },
  {
    name: 'perfumes',
    displayName: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-contrast-drop-line',
    description: 'Designer fragrances, niche scents & colognes',
  },
  {
    name: 'other-stuff',
    displayName: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    description: 'Everything else — electronics, home goods & more',
  },
];